'use client';

import { alpha, Box, Grid, SvgIcon } from '@mui/material';
import PythonLogoSingleColorIcon from '@repo-foundation/icons/PythonLogoSingleColorIcon';
import { INK_BASIC_LECTURES } from '@repo-foundation/ink-constants';
import { CodingListRow } from '@repo-ui/components/CodingListRow';
import { LectureViewDialogOpenEvent } from '@repo-ui/events/lecture-open';
import { useLocale } from 'next-intl';
import { useMemo } from 'react';
import { toast } from 'react-toastify';

const LOGO_HEIGHT = 140;

interface Props {}

export function BlockCodingList(props: Props) {
  const locale = useLocale();
  const DATA = useMemo(
    () => [
      {
        language: 'blox',
        title: '블록코딩',
        subtitle: '쉽고 강력한 프로그래밍',
        href: '/project/blox',
        tutorHref: '/tutor/blox',
        tint: '#00abfe',
        textColor: '#fff',
        logo: (
          <Box
            sx={{
              position: 'absolute',
              right: 10,
              bottom: 20,
              height: LOGO_HEIGHT,
              '& > svg': {
                color: alpha('#000', 0.15),
                width: 96,
                height: 96,
              },
            }}
          >
            <SvgIcon component={PythonLogoSingleColorIcon} inheritViewBox />
          </Box>
        ),
      },
      ...createSampleData(locale),
    ],
    [locale],
  );

  const handleClickLectureBtn = (lang: string) => () => {
    const info = INK_BASIC_LECTURES.find((it) => it.language === lang);
    if (!info) {
      toast.warn('등록된 강좌가 없습니다:' + lang);
      return;
    }

    LectureViewDialogOpenEvent.emit(info.lectureKey);
  };

  return (
    <Box className="BlockCodingList-root">
      <Grid container rowSpacing={3} columnSpacing={3}>
        {DATA.map((item) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={item.language}>
            <CodingListRow {...item} onClickLectureBtn={handleClickLectureBtn(item.language)} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

function createSampleData(locale: string) {
  return [
    // {
    //   language: 'bolck1',
    //   title: '블록코딩',
    //   subtitle: '쉽고 강력한 프로그래밍',
    //   href: `/project/blox`,
    //   tutorHref: `/tutor/blox`,
    //   tint: '#00abfe',
    //   textColor: '#fff',
    //   logo: (
    //     <Box
    //       sx={{
    //         position: 'absolute',
    //         right: 10,
    //         bottom: 20,
    //         height: LOGO_HEIGHT,
    //         '& > svg': {
    //           color: alpha('#000', 0.15),
    //           width: 96,
    //           height: 96,
    //         },
    //       }}
    //     >
    //       <SvgIcon component={PythonLogoSingleColorIcon} inheritViewBox />
    //     </Box>
    //   ),
    // },

    {
      language: 'block2',
      title: '블록코딩',
      subtitle: '쉽고 강력한 프로그래밍',
      href: '/project/blox',
      tutorHref: '/tutor/blox',
      tint: '#FFB100',
      textColor: '#000',
      logo: (
        <Box
          sx={{
            position: 'absolute',
            right: 10,
            bottom: 20,
            height: LOGO_HEIGHT,
            '& > svg': {
              color: alpha('#000', 0.15),
              width: 96,
              height: 96,
            },
          }}
        >
          <SvgIcon component={PythonLogoSingleColorIcon} inheritViewBox />
        </Box>
      ),
    },

    {
      language: 'block3',
      title: '블록코딩',
      subtitle: '쉽고 강력한 프로그래밍',
      href: '/project/blox',
      tutorHref: '/tutor/blox',
      tint: '#DB2559',
      textColor: '#fff',
      logo: (
        <Box
          sx={{
            position: 'absolute',
            right: 10,
            bottom: 20,
            height: LOGO_HEIGHT,
            '& > svg': {
              color: alpha('#000', 0.15),
              width: 96,
              height: 96,
            },
          }}
        >
          <SvgIcon component={PythonLogoSingleColorIcon} inheritViewBox />
        </Box>
      ),
    },
  ];
}
